import { render } from "./oneTel.vue?vue&type=template&id=25245f80&scoped=true"
import script from "./oneTel.vue?vue&type=script&lang=js"
export * from "./oneTel.vue?vue&type=script&lang=js"

import "./oneTel.vue?vue&type=style&index=0&id=25245f80&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-service/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25245f80"]])

export default __exports__